import {FormInstance, InputRef} from "antd";
import {Ref} from "react";

type AbstractInput = {
	value: any,
	_valueTracker: any,
	dispatchEvent: any
}

export const getRefValue = (input: HTMLInputElement | Ref<InputRef> | null) => {
	// @ts-ignore
	if (input && input.hasOwnProperty("current") && input?.current?.hasOwnProperty("resizableTextArea"))
	{
		// @ts-ignore
		input = input.current?.resizableTextArea;

		if (input == null)
		{
			return null
		}

		// @ts-ignore
		return input?.textArea?.value || null;
	}

	if (input && input.hasOwnProperty("current"))
	{
		// @ts-ignore
		input = input.current?.input;
	}

	if (input == null)
	{
		return null
	}

	// input as HTMLInputElement
	if (!(input instanceof HTMLInputElement))
	{
		return;
	}

	try
	{
		return input.value;
	}
	catch (e)
	{
		console.error(e)
	}

	return null;
}

export const setRefValue = (input: HTMLInputElement | Ref<InputRef> | null, value: any) => {
	if (input && input.hasOwnProperty("current"))
	{
		// if textarea input is textArea
		// @ts-ignore
		if (input?.current?.hasOwnProperty("resizableTextArea"))
		{
			// @ts-ignore
			input = input.current?.resizableTextArea;

			if (input == null)
			{
				return
			}

			// @ts-ignore
			input = input?.textArea;
		}
		else
		{
			// @ts-ignore
			input = input.current?.input;
		}
	}

	if (input == null)
	{
		return
	}

	try
	{
		// @ts-ignore
		let lastValue = input.value;
		// @ts-ignore
		input.value = value;

		let event = new Event('input', {bubbles: true});
		// @ts-ignore
		event.simulated = true;

		// @ts-ignore
		let tracker = input._valueTracker || false;
		if (tracker)
		{
			tracker.setValue(lastValue);
		}

		// @ts-ignore
		input.dispatchEvent(event);
	}
	catch (e)
	{
		console.error(e)
	}
}

export const useShowErrors = (api: any = null) => {
	return [
		(errors: any, form: FormInstance | null = null, duration: number = 6) => {
			// if errors string
			if (typeof errors == "string")
			{
				errors = {
					"0": [errors]
				}
			}

			// if not undefined null and other
			if (errors == null || (errors instanceof Array && errors.length == 0))
			{
				return;
			}

			if (errors instanceof Array)
			{
				const transformed: any = {};

				for (let i = 0; i < errors.length; i++)
				{
					const error = errors[i];

					transformed[i] = error;
				}

				errors = transformed;
			}

			for (const key in errors)
			{
				if (form && form?.getFieldsValue() && form?.getFieldsValue().hasOwnProperty(key))
				{
					form.setFields([
						{
							name: key,
							errors: errors[key] instanceof Array ? errors[key] : [errors[key]]
						}
					])

					delete errors[key];
				}
			}

			if (Object.keys(errors).length > 0 && api != null)
			{
				for (const key in errors)
				{
					api.error({
						title: "Error",
						message: (errors[key] instanceof Array ? errors[key].join("\n") : errors[key]?.toString()) || "Error",
						duration: duration
					})
				}
			}
		},
		// clear errors form
		(form: FormInstance | null = null) => {
			if (form)
			{
				for (const key in form.getFieldsValue())
				{
					form.setFields([
						{
							name: key,
							errors: []
						}
					])
				}
			}
		}
	]
}